import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { setHideHeaderLinks } from "../Redux/OverlayActions";
import LanguageSelector from "./Header/LanguageSelector";
import HeaderMenu from "./Header/HeaderMenu";
import HamburgerButton from "./Header/HamburgerButton";
import { getItem, STORAGE_KEYS } from "../utils/storage";

const updateBarStyle = {
    backgroundColor: process.env.REACT_APP_THEME_COLOR,
    textAlign: "center",
    color: process.env.REACT_APP_THEME_TEXT_COLOR,
    padding: "0.25rem",
    display: "none",
    zIndex: "1030",
};

function Header() {
    const dispatch = useDispatch();
    const [expanded, setExpanded] = useState(false);

    const hideHeader = useSelector(state => state.overlay.hideHeader || false);
    const hideHeaderLinks = useSelector(state => state.overlay.hideHeaderLinks || false);

    useEffect(() => {
        const consent = getItem(STORAGE_KEYS.CONSENT, false);
        dispatch(setHideHeaderLinks(!consent));
    }, [dispatch]);

    const toggleExpanded = useCallback(() => {
        setExpanded(prev => !prev);
    }, []);

    const closeExpanded = useCallback(() => {
        setExpanded(false);
        // Also close the Bootstrap collapse programmatically
        try {
            const navbarCollapse = document.getElementById('navbarNavAltMarkup');
            if (navbarCollapse?.classList.contains('show')) {
                navbarCollapse.classList.remove('show');
            }
        } catch (error) {
            console.warn('[Header] Failed to close navbar collapse:', error);
        }
    }, []);

    if (hideHeader) {
        return null;
    }

    const overlay = expanded ? (
        <div
            onClick={closeExpanded}
            onKeyDown={(e) => e.key === 'Escape' && closeExpanded()}
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavAltMarkup"
            className="dark-overlay"
            role="button"
            tabIndex={0}
            aria-label="Close menu"
        />
    ) : null;

    const menuItems = !hideHeaderLinks ? (
        <div className="header-nav-container">
            <LanguageSelector />
            <HamburgerButton
                isOpen={expanded}
                onClick={toggleExpanded}
            />
            <HeaderMenu closeExpanded={closeExpanded} />
        </div>
    ) : null;

    return (
        <div className="fixed-top">
            <div id="updateBar" style={updateBarStyle}>
                <button
                    type="button"
                    id="updateBarReload"
                    style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0 }}
                >
                    Er is een nieuwe versie van de app beschikbaar. Klik hier om te updaten.
                </button>
            </div>
            <nav className="navbar navbar-expand-lg navbar-light" style={{ zIndex: "1030" }}>
                <div className="container">
                    <Link className="navbar-brand" to="/">
                        <img id="logo" alt="logo foubert" src={window.location.origin + '/images/logo.png'} />
                    </Link>
                    {menuItems}
                </div>
            </nav>
            {overlay}
        </div>
    );
}

export default Header;
